import data from './data';
import computed from './computed';
import oncreate from './oncreate';
import ondestroy from './ondestroy';
import onrender from './onrender';
import onteardown from './onteardown';
import helpers from './helpers';
import methods from './methods';
import components from './components';
import events from './events';
import namespace from './namespace';
import preload from './preload';
import props from './props';
import tag from './tag';
import transitions from './transitions';
import setup from './setup';
import store from './store';

export default {
	data,
	computed,
	oncreate,
	ondestroy,
	onrender,
	onteardown,
	helpers,
	methods,
	components,
	events,
	namespace,
	preload,
	props,
	tag,
	transitions,
	setup,
	store,
};
